(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["plikt-videosektion"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MUTE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="m23 9-6 6M17 9l6 6"/></svg>';
  var FULL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';
  var EXIT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  function fsEl(){return document.fullscreenElement||document.webkitFullscreenElement||null}
  var SOUND='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  function init(root){
    if(!root||root.__pvs)return; root.__pvs=1;
    var track=root.querySelector('.pvs-track'), all=[].slice.call(track.querySelectorAll('.pvs-card')), dots=root.querySelector('.pvs-dots'), arrows=root.querySelectorAll('.pvs-arrow'), last=-1;
    if(!all.length)return;
    function vis(){return all.filter(function(c){return !c.hidden})}
    function stop(c){var v=c.querySelector('video');if(v)v.pause();c.classList.remove('is-playing')}
    function pauseAll(ex){all.forEach(function(c){if(c!==ex)stop(c)})}
    function exitFull(c){
      if(!c||!c.classList.contains('is-full'))return;
      c.classList.remove('is-full');c.querySelector('.pvs-full').innerHTML=FULL;c.querySelector('.pvs-full').setAttribute('aria-label','Helskärm');
      document.documentElement.style.overflow='';
      if(fsEl()===c){if(document.exitFullscreen)document.exitFullscreen().catch(function(){});else if(document.webkitExitFullscreen)document.webkitExitFullscreen();}
    }
    function enterFull(c,v){
      pauseAll(c);
      c.classList.add('is-full');c.querySelector('.pvs-full').innerHTML=EXIT;c.querySelector('.pvs-full').setAttribute('aria-label','Stäng helskärm');
      document.documentElement.style.overflow='hidden';
      try{
        if(c.requestFullscreen){var r=c.requestFullscreen();if(r&&r.catch)r.catch(function(){})}
        else if(c.webkitRequestFullscreen){c.webkitRequestFullscreen()}
      }catch(err){}
      if(v&&v.paused){if(!c.dataset.started){v.muted=false;c.querySelector('.pvs-mute').innerHTML=SOUND;c.dataset.started=1}var p=v.play();if(p&&p.catch)p.catch(function(){});c.classList.add('is-playing')}
    }
    function onFsChange(){var c=track.querySelector('.is-full');if(c&&fsEl()!==c&&!c.__css)exitFull(c)}
    document.addEventListener('fullscreenchange',onFsChange);document.addEventListener('webkitfullscreenchange',onFsChange);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')exitFull(track.querySelector('.is-full'))});
    function center(c){track.scrollTo({left:c.offsetLeft-(track.clientWidth-c.offsetWidth)/2,behavior:'smooth'})}
    all.forEach(function(c){
      var v=c.querySelector('video'),bar=c.querySelector('.pvs-prog i'),mb=c.querySelector('.pvs-mute');
      function setMute(m){if(v)v.muted=m;mb.innerHTML=m?MUTE:SOUND}
      setMute(true);
      if(v){
        v.addEventListener('timeupdate',function(){bar.style.width=((v.currentTime/v.duration)*100||0)+'%'});
        v.addEventListener('ended',function(){c.classList.remove('is-playing')});
      }
      c.addEventListener('click',function(e){
        if(e.target.closest('.pvs-link'))return;
        if(!c.classList.contains('is-act')){e.preventDefault();center(c);return}
        if(!v)return;
        if(e.target.closest('.pvs-mute')){setMute(!v.muted);return}
        if(e.target.closest('.pvs-full')){if(c.classList.contains('is-full'))exitFull(c);else enterFull(c,v);return}
        if(e.target.closest('.pvs-prog')){var r=e.target.closest('.pvs-prog').getBoundingClientRect();if(v.duration)v.currentTime=(e.clientX-r.left)/r.width*v.duration;return}
        if(v.paused){pauseAll(c);if(!c.dataset.started){setMute(false);c.dataset.started=1}var p=v.play();if(p&&p.catch)p.catch(function(){});c.classList.add('is-playing')}
        else stop(c);
      });
    });
    function upd(force){
      if(track.querySelector('.is-full'))return;
      var cs=vis();if(!cs.length)return;
      var mid=track.scrollLeft+track.clientWidth/2,idx=0,best=1e9;
      cs.forEach(function(c,i){var d=Math.abs(c.offsetLeft+c.offsetWidth/2-mid);if(d<best){best=d;idx=i}});
      all.forEach(function(c){c.classList.toggle('is-act',c===cs[idx])});
      if(idx!==last||force){
        pauseAll(null);last=idx;dots.innerHTML='';
        cs.forEach(function(c,i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Video '+(i+1));if(i===idx)b.className='is-on';b.onclick=function(){center(c)};dots.appendChild(b)});
      }
      arrows.forEach(function(a){a.disabled=a.dataset.dir<0?idx===0:idx===cs.length-1});
    }
    var raf;track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){upd()})},{passive:true});
    window.addEventListener('resize',function(){upd(true)});
    arrows.forEach(function(a){a.addEventListener('click',function(){var cs=vis(),i=cs.indexOf(track.querySelector('.is-act'))+(+a.dataset.dir);if(cs[i])center(cs[i])})});
    root.querySelectorAll('.pvs-tab').forEach(function(t){t.addEventListener('click',function(){
      root.querySelectorAll('.pvs-tab').forEach(function(x){x.setAttribute('aria-pressed',x===t?'true':'false')});
      var cat=t.dataset.cat;pauseAll(null);
      all.forEach(function(c){c.hidden=!!cat&&c.dataset.cat!==cat});
      track.scrollLeft=0;last=-1;upd(true);
    })});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(en){if(!en.isIntersecting)pauseAll(null)})},{threshold:.15}).observe(root);
    }
    upd(true);
  }
  function boot(){document.querySelectorAll('[data-pvs]').forEach(init)}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-pvs]'))});
})();

  } catch(e) { console.error(e); }
})();
})();
